export default __webpack_public_path__ + "img/0009104cd26a5d9e71b049a1fb824f25.svg";